import { render, staticRenderFns } from "./TeacherNotification.vue?vue&type=template&id=46be4f51"
import script from "../../services/notification/teacher-notification.js?vue&type=script&lang=js&external"
export * from "../../services/notification/teacher-notification.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/notification/teacher-notification.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports